/**
 * Logo : 
 */

import React from 'react';

/*-------- Css --------- */
import './index.style.css';
import logo from '../../assets/img/logo2.png';

const Logo = () =>{
  
return(
      <>
       {/*--- Start Logo     ----*/}
       {/* <Link to="/#home"> */}
       <div className="logo">
        <a href="#home">
          <img src={logo} alt="codewithkp" />
        </a>
       </div>
       {/* </Link> */}
       {/*--- End Logo   ----*/}
      </>
    )
}

export default Logo;